import { LoadingIndicator } from "@/app/(shop)/services/[slug]/components/loadingIndicator";
import OtpInput from "react-otp-input";
import { EmailSendCodeIcon } from "../_icons/emailSendCodeIcon";
import { SendCodeIcon } from "../_icons/sendCodeIcon";
import { TextButton } from "../button/textButton";
import { UseFormSetValue } from "react-hook-form";
import { LoginFormFields } from "./loginInfoModal";
import { LeftArrowModalIcon } from "./leftArrowModalIcon";
import CloseIcon from "../_icons/closeIcon";
import useMediaQuery from "@/utils/useMediaQuery";

export const LoginModalOTPInput = ({
  setValue,
  phoneField,
  emailField,
  setErrorMessage,
  onRequestClose,
  merchantColor,
  showPhoneNumberInput,
  errorMessage,
  isLoading,
  captchaRef,
  setShowVerification,
  setCode,
  getValues,
  code,
}: {
  setValue: UseFormSetValue<LoginFormFields>;
  phoneField: keyof Pick<LoginFormFields, "phone">;
  emailField: keyof Pick<LoginFormFields, "email">;
  setErrorMessage: (message: string | null) => void;
  onRequestClose: () => void;
  merchantColor: string;
  showPhoneNumberInput: boolean;
  errorMessage: string | null;
  isLoading: boolean;
  captchaRef: any;
  setShowVerification: (show: boolean) => void;
  setCode: (code: string) => void;
  getValues: () => { phone?: string; email?: string };
  code: string;
}) => {
  const isMobile = useMediaQuery("(max-width: 640px)");

  const otpContainerStyle = {
    width: "100%",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    display: "flex",
    justifyContent: "center",
    marginTop: "4rem",
    marginBottom: "4rem",
  };

  const otpInputStyle = {
    borderStyle: "solid",
    borderBottom: "4px solid #C7C7C7",
    borderColor: "#C7C7C7",
    borderRadius: "0",
    fontWeight: "bold",
    fontSize: isMobile ? "2rem" : "3.5rem",
    height: "5rem",
    margin: "0 0.3125rem",
    padding: "0 0 2rem 0",
    width: isMobile ? "3rem" : "5.375rem",
    marginLeft: "0.3125rem",
    marginRight: "0.3125rem",
    backgroundColor: "transparent",
  };

  return (
    <div className="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-[auto] sm:w-[70%] mx-auto overflow-hidden">
      <div className="flex justify-between items-center px-6 pt-6">
        <button
          onClick={() => {
            setErrorMessage(null);
            setShowVerification(false);
            setCode("");
          }}
          className="text-gray-600 hover:text-gray-900 mr-auto"
        >
          <LeftArrowModalIcon />
        </button>
        <button
          onClick={() => {
            setValue(phoneField, "");
            setValue(emailField, "");
            onRequestClose();
            setShowVerification(false);
            setCode("");
            setErrorMessage(null);
          }}
          className="text-gray-600 hover:text-gray-900 ml-auto"
        >
          <CloseIcon />
        </button>
      </div>
      <div className="px-4 pb-4 flex flex-col justify-center items-center">
        {showPhoneNumberInput && <SendCodeIcon brandingColor={merchantColor} />}
        {!showPhoneNumberInput && (
          <EmailSendCodeIcon brandingColor={merchantColor} />
        )}
        <p className="mt-4 text-3xl font-medium text-center text-neutral-700">
          {`Verify your ${
            showPhoneNumberInput ? `phone number` : `email address`
          }`}
        </p>
        <p className="mt-5 text-base leading-6 text-center text-[15px] text-neutral-700 sm:w-[460px]">
          A 6-digit code was just sent to{" "}
          <span className="font-bold">
            {showPhoneNumberInput ? getValues().phone : getValues().email}
          </span>
          . Please enter it below to keep your account information safe.
        </p>
        <div className="">
          {isLoading ? (
            <LoadingIndicator />
          ) : (
            <OtpInput
              numInputs={6}
              value={code}
              onChange={setCode}
              containerStyle={otpContainerStyle}
              inputStyle={otpInputStyle}
              focusStyle={{ borderColor: merchantColor, outline: "none" }}
              errorStyle={{
                outline: "none",
              }}
              isInputNum={true}
              shouldAutoFocus={true}
            />
          )}
        </div>
        {errorMessage && code.length === 6 && (
          <div className="text-red-600 text-sm mt-2">{errorMessage}</div>
        )}
        <TextButton
          style={{ color: merchantColor }}
          className="mt-8 mb-6 text-xl font-medium leading-7 text-center text-[#228800] max-md:mt-10"
          onClick={() => {
            setCode("");
            setErrorMessage(null);
            captchaRef.current?.reset();
            captchaRef.current?.execute();
          }}
        >
          Re-send Code
        </TextButton>
      </div>
    </div>
  );
};
